module.exports = __webpack_public_path__ + "img/1.95d14994.jpg";